import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Message } from '@arco-design/web-vue';
import { Modal } from '@arco-design/web-vue';
import { localStorage } from '@/utils/storage';
import i18 from '@/lang/index';
import useStore from '@/store';
import { removeEmptyKeys } from './common';
import xmlRequest from '@/lang/zh-cn';
// 创建 axios 实例
const service = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API,
  timeout: 50000,
  headers: { 'Content-Type': 'application/json;charset=utf-8' }
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    if (!config.headers) {
      throw new Error(`Expected 'config' and 'config.headers' not to be undefined`);
    }
    const { user } = useStore();
    if (user.userInfo?.token) {
      config.headers.authorization = `Bearer ${user.userInfo.token}`;
    }
    // 移除json请求数据中的空值
    if (
      config.data &&
      ['application/json;charset=utf-8'].includes(config.headers['Content-Type'] as string)
    ) {
      config.data = removeEmptyKeys(config.data);
    }

    // 移除get请求数据中的空值
    if (config.params) {
      config.params = removeEmptyKeys(config.params);
    }

    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response: AxiosResponse) => {
    const { code, message } = response.data;
    if (code == 200) {
      return response.data;
    } else if (code == '401') {
      const { user } = useStore();
      if (user.isShowUnLoginModal) return Promise.reject(response.data);
      user.setIsShowUnLoginModal(true);
      Modal.confirm({
        title: i18.global.t('xmlRequest.提示'),
        content: i18.global.t('xmlRequest.当前登录已失效'),
        okText: i18.global.t('xmlRequest.确认'),
        cancelText: i18.global.t('xmlRequest.再想想'),
        onOk: () => {
          localStorage.clear();
          window.location.href = '/login';
        },
        onCancel: () => {
          user.setIsShowUnLoginModal(false);
        }
      });
      return Promise.reject(response.data);
    } else {
      // 响应数据为二进制流处理(Excel导出)
      if (response.data instanceof ArrayBuffer) {
        return response.data;
      }
      if (xmlRequest.page[code]) {
        Message.error({
          content: i18.global.t('xmlRequest.' + code)
        });
        return Promise.reject(i18.global.t('xmlRequest.' + code));
      } else {
        Message.error({
          content: response.data.message
        });
        return Promise.reject(new Error(response.data.message));
      }
    }
  },
  (error: any) => {
    const { code, message } = error?.response?.data;

    if (code == '401') {
      const { user } = useStore();
      if (user.isShowUnLoginModal) return Promise.reject(message);
      user.setIsShowUnLoginModal(true);
      Message.error({
        content: i18.global.t('xmlRequest.当前登录已失效')
      });

      if (window.location.pathname.includes('/mobile/')) {
        window.location.href = '/mobile/login';
      } else {
        window.location.href = '/login';
      }

      return Promise.reject(message);
    }

    if (xmlRequest.page[code]) {
      Message.error({
        content: i18.global.t('xmlRequest.' + code)
      });
      return Promise.reject(i18.global.t('xmlRequest.' + code));
    } else {
      Message.error({
        content: message
      });
      return Promise.reject(new Error(message));
    }
    // 请求错误 清除token 跳转登录
    // localStorage.clear();
    // window.location.href = '/';
    // return Promise.reject(errorMsg);
  }
);

// 导出 axios 实例
export default service;
